import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCreative } from "swiper/modules";
import { graphql, StaticQuery } from "gatsby";
import "swiper/css";
import "swiper/css/navigation";
import ButtonBlock from "./ButtonBlock";
import { GatsbyImage } from "gatsby-plugin-image";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

const SliderPeakTemplate = ({ data, items }) => {
  console.log({ data, items });
  let { edges: products } = data.allMarkdownRemark;

  const [vw, setVw] = useState(1);

  useEffect(() => {
    setVw(window.innerWidth);
  }, []);

  return (
    <div className="peak-slider-section">
      <Swiper
        modules={[Navigation, EffectCreative]}
        speed={800}
        effect="slide"
        // creativeEffect={{
        //   prev: {
        //     translate: [vw > 768 ? "-60%" : 0, 0, -1],
        //     scale: vw > 768 ? 0.85 : 1,
        //     // opacity: 0.5,
        //   },
        //   next: {
        //     translate: [vw > 768 ? "60%" : 0, 0, 0],
        //     scale: vw > 768 ? 0.85 : 1,
        //     // opacity: 0.5,
        //   },
        // }}
        slidesPerView={3}
        centeredSlides={true}
        spaceBetween={30}
        loop={true}
        loopedSlides={2}
        loopPreventsSliding={true}
        loopAdditionalSlides={2}
        grabCursor={true}
        touchRatio={0.8}
        resistance={false}
        preventInteractionOnTransition={true}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        onSlideChange={(swiper) => {
          swiper.slides.forEach((slide) => {
            slide.style.transition = "all 600ms cubic-bezier(0.4, 0, 0.2, 1)";
          });
        }}
        className="peak-slider"
      >
        {products.map(({ node: { id, fields, frontmatter: { product, title, subtitle } } }) => (
          <SwiperSlide key={id} className="peak-slider-slide">
            <div className="slide-image">
              <PreviewCompatibleImage
                imageInfo={{
                  image: product.images[0].image,
                  alt:
                    title +
                    " " +
                    subtitle,
                  className: "featured-image",
                }} />
            </div>
            <div className="slide-content">
              <div className="slide-content-inner">
                <div className="slide-bottom">
                  <div>
                    <h2 className="slide-title">{title}</h2>
                    {/* <div className="slide-subtitle">{description}</div> */}
                  </div>
                  <ButtonBlock
                    link={fields.slug}
                    text={"Buy Now"}
                    className="slider__button-small"
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}

        <div className="peak-slider-arrows">
          <button className="slider-arrow prev swiper-button-prev">
            <div className="slider__arrow-wrapper">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.334 16H6.66732"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 6.66663L6.66667 16L16 25.3333"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
          <button className="slider-arrow next swiper-button-next">
            <div className="slider__arrow-wrapper">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66602 16H25.3327"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 6.66663L25.3333 16L16 25.3333"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        </div>
      </Swiper>
    </div>
  );
};


export default function SliderPeak(arg) {
  return (
    <StaticQuery
      query={graphql`
        query ProductsWithTestimonialsQuery {
          allMarkdownRemark(
            sort: { frontmatter: { title: ASC } }
            filter: { frontmatter: { templateKey: { eq: "store-post" } } }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  subtitle
                  product {
                    salePrice
                    price
                    brand
                    category
                    images {
                      image {
                        childImageSharp {
                          gatsbyImageData(
                            quality: 100
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          allGoogleRating {
            edges {
              node {
                name
                rating
                review
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <SliderPeakTemplate data={data} count={count} {...arg} />
      )}
    />
  )
}
